import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CampaignVariationsAnalysisState} from './campaignVariationsAnalysis.types';

const campaignVariationsAnalysisInitialState: CampaignVariationsAnalysisState = {
  inputsByNodeId: {},
  outputsByNodeId: {},
  assets: {
    feeds: {},
    locationFeeds: {},
    contentFeeds: {},
  },
  isActiveOnly: false,
  hasFetchedActive: false,
  hasFetchedAll: false,
};

const campaignVariationsAnalysisSlice = createSlice({
  name: 'variationsAnalysis',
  initialState: campaignVariationsAnalysisInitialState,
  reducers: {
    updateVariationsAnalysisAction: (
      state,
      action: PayloadAction<Partial<CampaignVariationsAnalysisState>>,
    ) => ({...state, ...action.payload}),
    resetVariationsAnalysisAction: () => campaignVariationsAnalysisInitialState,
  },
});

const {updateVariationsAnalysisAction, resetVariationsAnalysisAction} =
  campaignVariationsAnalysisSlice.actions;

export {updateVariationsAnalysisAction, resetVariationsAnalysisAction};

export default campaignVariationsAnalysisSlice.reducer;
